import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faHome,
    faBoxOpen,
    faBuilding,
    faAddressCard,
    faBrowser,
    faUserTag,
    faUserCog,
    faFolderOpen,
    faStreetView,
    faFileSpreadsheet,
    faFile,
    faFileAlt,
    faFilePlus,
    faStream,
    faClipboardList,
    faShieldCheck,
    faAbacus,
    faFileChartLine,
    faUsersMedical,
    faUsersCog,
    faUsers,
    faBookmark,
    faAnalytics,
    faChartLine,
    faFileUser,
    faPencil,
    faTimes,
} from '@fortawesome/pro-light-svg-icons'

library.add(
    faHome,
    faBoxOpen,
    faBuilding,
    faAddressCard,
    faBrowser,
    faUserTag,
    faUserCog,
    faFolderOpen,
    faStreetView,
    faFileSpreadsheet,
    faFile,
    faFileAlt,
    faFilePlus,
    faStream,
    faClipboardList,
    faShieldCheck,
    faAbacus,
    faFileChartLine,
    faUsersMedical,
    faUsersCog,
    faUsers,
    faBookmark,
    faAnalytics,
    faChartLine,
    faFileUser,
    faPencil,
    faTimes,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
